import classes from 'components/widgets/PhasePerformanceChart/PhasePerformanceChart.module.scss';
import { MilestoneIcon } from 'components/widgets/PhasePerformanceChart/components/MilestoneIcon/MilestoneIcon';

interface IMilestoneProps {
    name: string;
    projectName: string;
    isLast?: boolean;
}

export const Milestone = ({ name, projectName, isLast = false }: IMilestoneProps) => {
    return (
        <div className={`${classes.milestone} ${isLast ? classes.last : ''}`}>
            <div className={classes.title}>{name}</div>
            <MilestoneIcon projectName={projectName} name={name} />
        </div>
    );
};
